import React from "react";

const RadioIcon = (props) => {
  return (
    <div className="radio-button-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
      >
        <circle opacity="0.5" cx="7.5" cy="7.5" r="6.5" stroke="#AAAAB5" />
        {props.isSelected ? (
          <circle r="3.5" transform="matrix(-1 0 0 1 7.5 7.5)" fill="#EA6B3D" />
        ) : null}
      </svg>
    </div>
  );
};

export default RadioIcon;
